import CustomButton from '../../components/CustomButton.js';
import CustomCarousal from '../../components/CustomCarousal.js';
import { useNavigate } from 'react-router-dom';
import { FaQuoteLeft } from "react-icons/fa6";
import { useState, useRef, useEffect } from 'react';
import { FaApple } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa";
import { IoPeopleOutline } from "react-icons/io5";
import { FaStarHalfAlt } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { IoDiamondOutline } from "react-icons/io5";
import FindAppFooter from '../../components/FindAppFooter.js';
import '../../assets/css/Home.css';
import { useSelector } from "react-redux";
import '../../assets/css/Footer.css';
import tab from '../../assets/images/tab.png';
import appFeature from '../../assets/images/AppFeature-removebg-preview.png';
import ClearURL from "../../components/ClearURL";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { toast } from "react-toastify";
import 'bootstrap/dist/css/bootstrap.min.css';
import { SiGoogleplay } from "react-icons/si";
import googleStore from '../../assets/images/img-google-play.png';
import appStore from '../../assets/images/img-app-store.png'
import AppFeature from '../../components/AppFeature.js';


const Home = () => {
    const navigate = useNavigate();
    const onSignUpUser = () => {
        navigate('/register');
    }
    const [slideData, setSlideData] = useState();
    const cardData = [
        { title: 'David', content: 'A well-implemented security, privacy, and account management system improves trust and user experience. The game should ensure data protection, fair play, and secure transactions for all players.' },
        { title: 'Emma', content: 'A well-implemented security, privacy, and account management system improves trust and user experience. The game should ensure data protection, fair play, and secure transactions for all players.' },
        { title: 'Sophia', content: 'A well-implemented security, privacy, and account management system improves trust and user experience. The game should ensure data protection, fair play, and secure transactions for all players.' },
    ];
    const slidesData = [
        {
            name: "Ray Robertson",
            role: "CEO Company",
            text: "A well-implemented security, privacy, and account management system improves trust and user experience. The game should ensure data protection, fair play, and secure transactions for all players.",
            avatar: "https://randomuser.me/api/portraits/men/1.jpg",
        },
        {
            name: "Sheri",
            role: "CEO Company",
            text: "A well-implemented security, privacy, and account management system improves trust and user experience. The game should ensure data protection, fair play, and secure transactions for all players",
            avatar: "https://randomuser.me/api/portraits/women/2.jpg",
        },
    ];
    useEffect(() => {
        const fetchFeedback = async () => {
            try {
                // setShowSpinner(true);
                const result = await apiHandler({
                    url: endpoint.FETCH_FEEDBACK,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });

                if (result?.data.code !== 500) {
                    setSlideData(result?.data);
                } else {
                    toast.error("Something went wrong");
                }
            } catch (error) {
                toast.error("Something went wrong");
            } finally {
                // setShowSpinner(false);
            }
        };
        fetchFeedback();
    }, [])


    const statsData = [
        { icon: <IoPeopleOutline style={{ fontSize: '45px', color: '#02b8a5' }} />, count: 120, label: "Happy Users" },
        { icon: < FaStarHalfAlt style={{ fontSize: '45px', color: '#02b8a5' }} />, count: 46, label: "Positive Ratings" },
        { icon: <FaDownload style={{ fontSize: '45px', color: '#02b8a5' }} />, count: 125, label: "Total Download" },
        { icon: <IoDiamondOutline style={{ fontSize: '45px', color: '#02b8a5' }} />, count: 58, label: "Premium Users" },
    ];
    const [counts, setCounts] = useState(statsData.map(() => 0));

    const { accessToken } = useSelector((state) => state.loginInfo);

    const [showText, setShowText] = useState(true);
    const divRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (divRef.current) {
                const { top } = divRef.current.getBoundingClientRect();
                if (top <= 50) {
                    setShowText(false);
                } else {
                    setShowText(true);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const [hasAnimated, setHasAnimated] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const handleIntersection = ([entry]) => {
            if (entry.isIntersecting) {
                setHasAnimated(true);
            }
        };

        const observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.5,
        });

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (hasAnimated) {
            const timers = statsData.map((item, index) => {
                const increment = Math.ceil(item.count / 100);
                const timer = setInterval(() => {
                    setCounts((prevCounts) => {
                        const newCounts = [...prevCounts];
                        if (newCounts[index] < item.count) {
                            newCounts[index] = Math.min(newCounts[index] + increment, item.count);
                        }
                        return newCounts;
                    });
                }, 20);
                return timer;
            });

            // Cleanup intervals
            return () => {
                timers.forEach(clearInterval);
            };
        }
    }, [hasAnimated, statsData]);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const el = document.querySelector(hash);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                }
            }, 100); // delay to ensure DOM is ready
        }
    }, []);



    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY < 10 && !window.location.hash) {
                navigate("/");
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [navigate]);

    const onOpenPrivacyPolicy = () => {
        navigate('/privacy-policy')
    }
    const onTermAndCondition = ()=>{
        navigate('/term-condition')
    }

    return (
        <>
            <div >
                <ClearURL />
                <div className='home-banner' >
                    <div className='d-flex align-items-center  w-100 banner-text-wrapper' >
                        <div className='' ref={divRef} style={{ transition: "opacity 0.5s ease", opacity: showText ? 1 : 0, width: '419px' }}>
                            <div className='text-white fs-1 fs-sm-4 fs-md-1  fw-bold text-left explore-play-txt ' >Explore, play, <br />and enjoy endless fun</div>
                            <div className=' mt-4 d-flex'>
                                {!accessToken.accessToken &&
                                    <CustomButton buttonText={'Create Account'} className="create-account" onClick={onSignUpUser} />
                                }
                            </div>
                        </div>

                    </div>
                </div>

                {/* -------------------------Heading Section--------------------------- */}

                <div className="container mt-0 mt-sm-5" style={{ paddingTop: '40px', paddingBottom: '100px' }}>
                    <div className="text-center">
                        <h2 className="fw-bold  about-our-app-content" style={{ color: '#333' }}>
                            About Our App
                        </h2>
                        <p style={{ fontSize: '18px', color: '#6c757d' }}>
                            Play, Connect, and Compete!
                        </p>
                    </div>

                    {/* Content Section */}
                    <div className="row align-items-center mt-5">
                        {/* Left Section - Image */}
                        <div className="col-md-6 text-center">
                            <div className="position-relative">
                                <img
                                    src={tab}
                                    alt="App Design"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                        {/* Right Section - Text */}
                        <div className="col-md-6 about-our-app-txt">
                            <h2 className="fw-bold looking-for-tennis-txt mb-3 mb-sm-0" style={{ color: '#333' }}>
                                Looking for tennis or pickleball partners? Our app makes it easy!
                            </h2>
                            <p className='mt-3' style={{ color: '#6c757d' }}>
                                Looking for tennis or pickleball partners? Our app makes it easy!
                                With our Tennis & Pickleball Matchmaking App, you can create games, find players, and join matches near you. Whether you're a beginner or a pro, connect with like-minded players, schedule games, and enjoy playing together on the court.
                            </p>
                            <p style={{ color: '#6c757d' }}>
                                Seamless Experience Across All Platforms
                            </p>
                            <p style={{ color: '#6c757d' }}>
                                Our app is available on iOS, Android, and the web, so you can stay connected and manage your games anytime, anywhere.
                                &#x1F3C6; Find Matches | &#x1F3BE; Create Games | &#x1F91D; Meet Players
                            </p>


                            <div className='d-flex pb-4 align-items-center get-the-app-wrapper'>
                                <div className='me-3 fw-semibold get-the-app-txt' >GET THE APP</div>
                                <div className='me-3 app-store-btn'>
                                    < img src={googleStore} alt='google-store' style={{ cursor: 'pointer', width: '150px', height: '44px' }} />
                                </div>
                                <div className='me-3'>
                                    < img src={appStore} alt='app-store' style={{ cursor: 'pointer', width: '150px', height: '44px' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*---------------------- ---ABOUT USER SECTION ------------------------*/}

                <div className="stats-section" ref={sectionRef}>
                    <div className="container" style={{ padding: '43px', background: 'black' }}>
                        <div className="row">
                            <div className="d-flex justify-content-around align-items-center row">
                                {statsData.map((item, index) => (
                                    <div key={index} className="stat-item text-center text-white col-sm-12 col-md-6 col-lg-3 mb-4">
                                        <div>{item.icon}</div>
                                        <h3 className="stat-count">{counts[index]}</h3>
                                        <p className="stat-label">{item.label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <section id='app-features'>
                    <AppFeature />
                </section>

                {/* --------------------------------FOOTER----------------------------------------  */}
                <FindAppFooter />
                <div className='footer-strip-wrapper '>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-2 Itengo-txt d-flex justify-content-around d-sm-block' > <span className='privacy-and-term-condition me-1' onClick={() => onOpenPrivacyPolicy()}>Privacy Policy</span> | <span className='privacy-and-term-condition' onClick={()=> onTermAndCondition()}>Team & Condition</span></div>
                            <div className='col-lg-10 d-flex justify-content-around'>
                                <div className='copy-right-txt'> Copyright ©2025 <span className='Itengo-txt'>ITenGo.Pro</span> All Right Reserved</div>
                                <div className='copy-right-txt'>Developed by <span className='Itengo-txt'>Perfectkode</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Home;
